"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVehicleModel = void 0;
const get_component_from_item_by_id_1 = require("./components/get-component-from-item-by-id");
const get_component_values_1 = require("./components/get-component-values");
const enums_1 = require("../../../enums");
const legacy_mappers_1 = require("./legacy-mappers");
const map_pricing_1 = require("./map-pricing");
// @ts-ignore
const lodash_1 = require("lodash");
const mapVehicleModel = (salesPackage) => {
    var _a, _b, _c;
    const model = salesPackage === null || salesPackage === void 0 ? void 0 : salesPackage.model;
    const modelSeries = model === null || model === void 0 ? void 0 : model.modelSeries;
    const manufacturer = modelSeries === null || modelSeries === void 0 ? void 0 : modelSeries.manufacturer;
    const seriesBrand = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'seriesBrand'));
    const salesArticle = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'salesArticle'));
    const vehicleType = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(model, 'carType'));
    const availableOnNext = (0, get_component_values_1.getBooleanComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(model, 'availableOnNext'));
    const { Car, Motor, Electric } = (0, get_component_values_1.getPropertiesTableValues)((0, get_component_from_item_by_id_1.getComponentFromItemById)(model, 'properties'));
    const { bodyType, luggageVolume, numberOfSeats, modelYear, towingCapacity } = Car;
    const { fuel, powertrain, transmission, consumption, effect } = Motor;
    const { electricRange, batteryCapacity, chargingCapacityAC, chargingCapacityDC } = Electric;
    const fuelEnumValue = (0, enums_1.getFuelEnumValueByName)(fuel);
    const standardEquipmentChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'standardEquipment'));
    const equipment = standardEquipmentChunks === null || standardEquipmentChunks === void 0 ? void 0 : standardEquipmentChunks.flatMap((chunk) => { var _a; return (_a = chunk[0].content) === null || _a === void 0 ? void 0 : _a.text; });
    const { importerSupport, deliveryCharge, oneTimeFee, wreckage, source, importerSupportExcludingVat, deliveryChargeExcludingVat, wreckageExcludingVat, } = (0, map_pricing_1.mapVehicleModelPricing)(salesPackage);
    return {
        id: (_a = model === null || model === void 0 ? void 0 : model.id) !== null && _a !== void 0 ? _a : null,
        name: (_b = model === null || model === void 0 ? void 0 : model.name) !== null && _b !== void 0 ? _b : null,
        modelCode: seriesBrand !== null && seriesBrand !== void 0 ? seriesBrand : null,
        bodywork: {
            name: bodyType !== null && bodyType !== void 0 ? bodyType : null,
            type: (0, enums_1.getBodyworkEnumValueByName)(bodyType),
        },
        consumption: consumption !== null && consumption !== void 0 ? consumption : null,
        effect: effect !== null && effect !== void 0 ? effect : null,
        electricProps: {
            batteryCapacity: batteryCapacity !== null && batteryCapacity !== void 0 ? batteryCapacity : null,
            chargingCapacityAC: chargingCapacityAC !== null && chargingCapacityAC !== void 0 ? chargingCapacityAC : null,
            chargingCapacityDC: chargingCapacityDC !== null && chargingCapacityDC !== void 0 ? chargingCapacityDC : null,
            electricRange: electricRange !== null && electricRange !== void 0 ? electricRange : null,
        },
        equipment: [
            {
                name: 'Standardutstyr',
                equipment: (0, lodash_1.compact)(equipment !== null && equipment !== void 0 ? equipment : []),
            },
        ],
        fuel: {
            name: fuel !== null && fuel !== void 0 ? fuel : null,
            type: fuelEnumValue,
        },
        images: (0, legacy_mappers_1.mapImages)((_c = salesPackage === null || salesPackage === void 0 ? void 0 : salesPackage.defaultVariant) === null || _c === void 0 ? void 0 : _c.images),
        luggageVolume: parseInt(luggageVolume) || null,
        make: (0, enums_1.getMakeCodeByName)(manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.name),
        powerTrain: powertrain !== null && powertrain !== void 0 ? powertrain : null,
        pricing: {
            importerSupport,
            deliveryCharge,
            oneTimeFee,
            wreckage,
            source,
            importerSupportExcludingVat,
            deliveryChargeExcludingVat,
            wreckageExcludingVat,
        },
        salesArticle,
        seatCount: parseInt(numberOfSeats) || null,
        series: modelSeries === null || modelSeries === void 0 ? void 0 : modelSeries.name,
        towingCapacity: towingCapacity ? `${towingCapacity} kg` : null,
        transmission: transmission !== null && transmission !== void 0 ? transmission : null,
        vehicleType,
        year: parseInt(modelYear) || 0,
        availableOnNext: availableOnNext !== null && availableOnNext !== void 0 ? availableOnNext : null,
    };
};
exports.mapVehicleModel = mapVehicleModel;
//# sourceMappingURL=map-vehicle-model.js.map